/** Injected at build/dev time by Vite `define` (see vite.config.ts / vitest.config.ts). */
export const TIPI_BUSINESS_COUNT = __TIPI_BUSINESS_COUNT__
